export {};
//# sourceMappingURL=deflate.types.js.map